export class ThemeConstants {
    static DARK = '#121217';
    static LIGHT = '#fff';
}